// @ts-nocheck
import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import {
	FaTwitter,
	FaFacebook,
	FaWhatsapp,
	FaInstagram,
	FaYoutube,
	FaLinkedin,
	FaPiggyBank,
	FaCreditCard,
	FaUserGraduate,
} from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import donation from "../assets/images/donation.svg";
import pledge from "../assets/images/pledge.png";
import { db } from "../firebase/firebase";
import CountUp from "react-countup";

function Home() {
	const [email, setEmail] = useState("");
	const [role, setRole] = useState("");
	// const [loader, setLoader] = useState(false);

	const handleSubmit = (/** @type {{ preventDefault: () => void; }} */ e) => {
		e.preventDefault();
		// setLoader(true);
		db.collection("contacts")
			.add({
				email: email,
				role: role,
			})
			.then(() => {
				alert("Email has been saved 👍");
				// Set the loader to false after adding the data
				// setLoader(false);
			})
			.catch((error) => {
				alert(error.message);
				// Set the loader to false after adding the data
				// setLoader(false);
			});
		setEmail("");
		setRole("");
	};
	return (
		<section className="h-full font-poppins">
			{/* Heading and Motto section */}
			<div>
				<h1 className="font-bold text-4xl md:text-6xl text-center text-blue-500">
					Go Share
				</h1>
				<p className="uppercase md:font-bold text-md md:text-3xl text-center text-center text-blue-500 pt-4 pb-8 md:pb-8">
					Democratizing access to Tertiary education, one donation at
					a time.
				</p>
			</div>

			{/* Student funds and debt section */}
			<section className="w-full px-4 md:px-16">
				<div
					className="grid grid-cols-1 md:grid-cols-3 gap-4 justify-items-center rounded-lg shadow-2xl
                    text-base leading-relaxed text-blue-500 text-lg md:text-2xl font-bold text-center"
				>
					<div className="">
						<IconButton name="students">
							<span className="text-blue-500">
								<FaUserGraduate size="3em" />
							</span>
						</IconButton>
						<h2>
							<CountUp end={500} duration={2} />+
						</h2>
						<p>Students</p>
					</div>
					<div className="">
						<IconButton name="total debt">
							<span className="text-blue-500">
								<FaCreditCard size="3em" />
							</span>
						</IconButton>
						<h3>
							R<CountUp end={1000000} duration={2} />
						</h3>
						<p>Debt</p>
					</div>
					<div className="">
						<IconButton name="fund raised">
							<span className="text-blue-500">
								<FaPiggyBank size="3em" />
							</span>
						</IconButton>
						<h3>
							R <CountUp end={500} duration={2} />
						</h3>
						<p>Raised</p>
					</div>
				</div>
			</section>

			{/* Donation pledge and confirmation section */}
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-16 justify-items-center pt-8 pb-8 px-4 md:px-16">
				<div className="w-full rounded-lg shadow-2xl overflow-hidden flex flex-col md:flex-row">
					<div className="w-full md:w-3/5 h-80">
						<img
							className="object-center object-contain w-full h-full"
							src={donation}
							alt="confirm donation"
						/>
					</div>
					<div className="w-full md:w-3/5 text-center md:text-left p-6 md:p-4 space-y-2">
						<h5 className="text-base leading-relaxed text-gray-500 font-normal">
							Bank Name: FNB
						</h5>
						<h5 className="text-base leading-relaxed text-gray-500 font-normal">
							Account Holder: GoShare NPC
						</h5>
						<h5 className="text-base leading-relaxed text-gray-500 font-normal">
							Account Number: 62918341299
						</h5>
						<h5 className="text-base leading-relaxed text-gray-500 font-normal">
							Branch Code: 260548
						</h5>
						<h5 className="text-base leading-relaxed text-gray-500 font-normal">
							Reference: Your email
						</h5>
						<div className="flex justify-start space-x-2">
							<button
								type="button"
								value="button"
								className="text-white bg-blue-500 hover:bg-cyan-100 hover:text-blue-500 m-auto my-4 px-6 py-2 text-lg rounded-lg shadow-px-4 border-0"
							>
								Confirm Payment
							</button>
						</div>
					</div>
				</div>
				<div className="w-full rounded-lg shadow-2xl overflow-hidden flex flex-col md:flex-row">
					<div className="w-full md:w-3/5 h-80">
						<img
							className="object-center object-contain w-full h-full"
							src={pledge}
							alt="pledge"
						/>
					</div>
					<div className="w-full md:w-3/5 text-left p-6 md:p-4 space-y-2">
						<p className="text-base leading-relaxed text-gray-500 font-normal">
							A pledge is a promise you make to GoShare, that once
							our platform is functional, you’ll donate the amount
							you committed to here.
						</p>
						<div className="flex justify-start space-x-2">
							<button
								type="button"
								value="button"
								className="text-white bg-blue-500 hover:bg-cyan-100 hover:text-blue-500 m-auto my-10 px-6 py-2 text-lg rounded-lg shadow-px-4 border-0"
							>
								I would like to pledge
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* SignUp section */}
			<section className="w-full px-4 md:px-16">
				<div className="rounded-lg shadow-2xl pb-16">
					<p
						className="uppercase md:font-bold text-sm md:text-2xl pb-8 pt-8 text-center"
						style={{ color: "#3c5b80" }}
					>
						Sign up to be the first to know when we launch our pilot
					</p>
					<div className="px-4 lg:px-64">
						<form
							className="newsletter-form is-revealing"
							onSubmit={handleSubmit}
						>
							<div className="grid grid-rows-2 md:flex gap-4 md:justify-center">
								<input
									className="py-2 md:py-4 text-sm md:text-lg text-gray-500 bg-white border border-blue-500 rounded-lg shadow-none px-auto hover:border-cyan-100 flex-grow"
									type="email"
									name="email"
									placeholder="Your best email&hellip;"
									value={email}
									required
									onChange={(e) => setEmail(e.target.value)}
								/>
								<div className="flex space-x-4">
									<select
										className="py-4 text-sm md:text-lg text-gray-500 bg-white border border-blue-500 rounded-lg shadow-none flex-shrink hover:border-cyan-100"
										name="role"
										value={role}
										onChange={(e) =>
											setRole(e.target.value)
										}
									>
										<option
											defaultValue="Choose role"
											hidden
										>
											Choose role
										</option>
										<option>Student</option>
										<option>Donor</option>
									</select>
									<button
										className="text-white py-4 px-auto shadow-lg rounded-lg font-bold text-sm md:text-lg bg-blue-500 hover:bg-cyan-100 hover:text-blue-500 flex-shrink w-full p-2"
										type="submit"
									>
										Early Access
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</section>

			{/* Footer section */}
			<footer className="w-full font-poppins h-48 sticky bg-blue-500">
				<div className="grid md:grid-flow-col m-8 justify-items-center pb-8 pt-8">
					<div className="text-white">
						<p className=" text-sm font-bold text-center md:text-lg">
							<a
								href="https://www.youtube.com/watch?v=ViKfuSn3R3I"
								target="_self"
							>
								<mark>Watch a Video</mark>
							</a>
						</p>
						<p className=" text-sm font-bold md:text-lg">
							&copy; Copyright by {new Date().getFullYear()}{" "}
							<mark>GoShare SA</mark>
						</p>
					</div>
					<div className="grid">
						<ul className="flex">
							<li>
								<IconButton
									className="social-icon-hover"
									name="Twitter"
								>
									<a
										href="https://mobile.twitter.com/Gosharesa"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="twitter-link"
									>
										<FaTwitter size="1.2em" color="cyan" />
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Facebook"
								>
									<a
										href="https://m.facebook.com/GOSHARESA/"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="facebook-link"
									>
										<FaFacebook
											size="1.2em"
											color="lightblue"
										/>
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Whatsapp"
								>
									<a
										href="https://wa.me/"
										rel="noopener noreferrer"
										target="_blank"
									>
										<FaWhatsapp
											size="1.2em"
											color="lightgreen"
										/>
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Linkedin"
								>
									<a
										href="https://m.youtube.com/channel/UCPpTzmg0VlTw5zRfg7vjlgA"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="email"
									>
										<SiGmail size="1.2em" color="darkred" />
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Instagram"
								>
									<a
										href="https://www.instagram.com/goshare_sa/"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="instagram-link"
									>
										<FaInstagram
											size="1.2em"
											color="#E1306C"
										/>
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Youtube"
								>
									<a
										href="https://m.youtube.com/channel/UCPpTzmg0VlTw5zRfg7vjlgA"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="instagram-link"
									>
										<FaYoutube size="1.2em" color="red" />
									</a>
								</IconButton>
							</li>
							<li>
								<IconButton
									className="social-icon-hover"
									name="Linkedin"
								>
									<a
										href="https://m.youtube.com/channel/UCPpTzmg0VlTw5zRfg7vjlgA"
										rel="noopener noreferrer"
										target="_blank"
										aria-label="linkedin-link"
									>
										<FaLinkedin
											size="1.2em"
											color="lightblue"
										/>
									</a>
								</IconButton>
							</li>
						</ul>
					</div>
				</div>
			</footer>
		</section>
	);
}

export default Home;
